<div class="row">
  <div class="col-4">
    <div class="content-header my-2 ml-1">
      <h4 class="font-weight-bold text-secondary mt-2 m-0">{{headerTitle}}</h4>
    </div>
  </div>
  <div class="col-8">
    <ng-content></ng-content>
  </div>
</div>